import React from "react";
import { IListingSummary } from "../../lib/Listing/types";
import { EWsrvTransform } from "../../lib/Media/util";
import FeaturedWithDropdownContent from "../Blades/FeaturedWithDropdownContent";
import { Button } from "../Button/Button";
import { Carousel } from "../Carousel";
import { ContactForm } from "../Forms/ContactForm";
import { EListingCardLayouts, ListingCard } from "../Listing/ListingCard";
import { EListingVitalsLayout } from "../Listing/ListingVitals";
import { WsrvImage } from "../Media/WsrvImage";
import { Search } from "../Search/Search";
import { ICommunityLayoutProps } from "./util";
import MapBlade from "../Blades/MapBlade";
import { ImageWithOverlappedTextBlade } from "../Blades/ImageWithOverlappedTextBlade";
import { MarketStats } from "../MarketStats/MarketStats";
import { BackgroundImage } from "../Media/BackgroundImage";

export const CommunityLayoutHeroGallery: React.FC<ICommunityLayoutProps> = ({
    heroCarouselImagesUrls,
    title,
    description,
    lifestyleItems,
    listings,
    listingsResultPageSize = 4,
    linkFunc,
    heroCarouselProps,
    lifestyleProps,
    listingsResultCardsProps,
    listingsSearchUrl,
    markets,
    marketReportBgImageUrl,
    showMarketStats = false,
    showListingSearch = true,
    showMap = true,
    showListingsCarousel = false,
    showContactUsForm = true,
    centerBlade,
    mapBladeProps,
    requestInfoFormProps,
    contactUsFormProps,
    centerBladeProps,
    marketStatsProps,
    listingsCarouselProps,
    listingsCarouselCardsProps,
}) => {

    let communityListings: IListingSummary[] = []
    let additionalResults = 0
    if (listings && listings.length > 0) {
        if (listings.length > listingsResultPageSize) {
            communityListings = listings.slice(0, listingsResultPageSize)
            additionalResults = listings.length - listingsResultPageSize
        }
        else {
            communityListings = listings
        }
    }

    let locations: any[] = []
    listings && listings.length && (
        locations = listings.filter((item: any) => { return item.location && item.location.lat && item.location.lng; })
    )

    let marketStats = markets && (
        <MarketStats
            markets={markets}
            title={`${title} Market Summary`}
            className="mx-auto"
            {...marketStatsProps}
        />
    );

    (marketStats && marketReportBgImageUrl) && (
        marketStats = (
            <div style={{ textShadow: "1px 1px 2px #3c3c3c" }}>
                <BackgroundImage
                    src={marketReportBgImageUrl}
                    className="p-12 inverted"
                    sizesAndAspect={[
                        {
                            width: 420,
                            aspect: EWsrvTransform.cover2x6,
                        },
                        {
                            media: "min-width:420px",
                            width: 640,
                            aspect: EWsrvTransform.cover2x6,
                        },
                        {
                            media: "min-width:640px",
                            width: 768,
                            aspect: EWsrvTransform.cover3x2,
                        },
                        {
                            media: "min-width:768px",
                            width: 1024,
                            aspect: EWsrvTransform.cover3x2,
                        },
                        {
                            media: "min-width:1024px",
                            width: 1280,
                            aspect: EWsrvTransform.cover16x9,
                        },
                        {
                            media: "min-width:1280px",
                            width: 1440,
                            aspect: EWsrvTransform.cover16x9,
                        },
                    ]}
                >
                    {marketStats}
                </BackgroundImage>
            </div>
        )
    )

    return (
        <>
            {heroCarouselImagesUrls && heroCarouselImagesUrls.length > 0 && (
                <Carousel
                    {...heroCarouselProps}
                >
                    {heroCarouselImagesUrls.map((url, index) => (
                        <WsrvImage
                            key={index}
                            widthMax={2400}
                            urlParams={{
                                originURL: url,
                                preset: EWsrvTransform.cover16x9,
                            }}
                            imgProps={{
                                className:
                                    "w-full h-screen max-h-screen object-cover object-center",
                                wrapperProps: {
                                    style: {
                                        display: "block",
                                        width: "100%"
                                    }
                                }
                            }}
                        ></WsrvImage>
                    ))}
                </Carousel>
            )}
            <div className="community-description relative mx-auto mt-10 py-9 w-full max-w-screen-xl flex flex-row flex-wrap lg:flex-nowrap inverted">
                <div className="w-full lg:w-auto lg:w-[55%] py-10 px-5 lg:px-10 lg:py-0">
                    <h1 className="text-center py-0 pb-9">{title}</h1>
                    <div
                        className="text-center leading-7 tracking-widest"
                        dangerouslySetInnerHTML={{
                            __html: description ?? ""
                        }}></div>
                </div>
                <div className="border mx-auto w-[90%] h-px lg:w-px lg:h-auto"></div>
                <div className="w-full lg:w-[45%] py-10 px-5 lg:pl-16 lg:pr-8 lg:py-0">
                    <ContactForm
                        title="Request Information"
                        classNames="strictTwoColumn inverted"
                        inputTextAreaLabel="Add a message here..."
                        {...requestInfoFormProps}
                    >
                    </ContactForm>
                </div>
            </div>
            {centerBlade && (
                <ImageWithOverlappedTextBlade {...centerBlade} {...centerBladeProps} />
            )}
            {showMarketStats && (
                marketStats
            )}
            {(showListingsCarousel && listings && listings.length > 3) && (
                <Carousel
                    title="Featured Properties"
                    slickSettings={{
                        centerMode: true,
                        infinite: true,
                        centerPadding: "22%",
                        slidesToShow: 1,
                        arrows: true,
                    }}
                    linkFunc={linkFunc}
                    className={`slick-center-zoom ${listingsCarouselProps?.className || ""
                        }`}
                    {...listingsCarouselProps}
                >
                    {listings.map((listing, index) => {
                        return (
                            <ListingCard
                                layout={EListingCardLayouts.vertical}
                                vitalsLayout={EListingVitalsLayout.row1Border0}
                                vitalsTwoLineAddress={false}
                                listing={listing}
                                linkFunc={linkFunc}
                                className="max-w-[1200px]"
                                maxWidthImage={1200}
                                imageClassProps="h-auto"
                                key={index}
                                {...listingsCarouselCardsProps}
                            />
                        );
                    })}
                </Carousel>
            )}
            {lifestyleItems && lifestyleItems.length > 0 && (
                <FeaturedWithDropdownContent
                    title="The Lifestyle"
                    subtitle="Experience the Maine seacoast"
                    className="community-lifestyle w-full max-w-screen-xl mx-auto px-5 lg:px-0 pt-20"
                    contentOptions={lifestyleItems}
                    {...lifestyleProps}
                >
                </FeaturedWithDropdownContent>
            )}
            {(showListingSearch && communityListings.length > 0) && (
                <>
                    <div className="w-full max-w-screen-xl mx-auto pt-20">
                        <h1>Listings</h1>
                        <Search
                            index={communityListings}
                            pageSize={0}
                            renderItem={(item, index) => (
                                <ListingCard
                                    listing={item}
                                    layout={EListingCardLayouts.vertical}
                                    className="w-[580px] max-w-full"
                                    maxWidthImage={580}
                                    vitalsLayout={EListingVitalsLayout.column2Border1}
                                    key={index}
                                    keyIndex={index}
                                    linkFunc={linkFunc}
                                    {...listingsResultCardsProps}
                                />
                            )}
                        />
                        {additionalResults > 0 && (
                            <div className="community-additional-results w-full max-w-screen mx-auto py-10 px-2 inverted flex flex-row flex-wrap justify-center items-center">
                                <span className="text-8xl font-light">{additionalResults}</span>
                                <h2 className="w-full md:w-60 mx-5 text-center md:text-left">Additional Results</h2>
                                <Button
                                    line={true}
                                    icon={false}
                                    linkProps={{
                                        href: listingsSearchUrl ?? "",
                                        className: `normal-case italic font-normal`,
                                    }}
                                    linkFunc={linkFunc}
                                >
                                    View All
                                </Button>
                            </div>
                        )}

                    </div>
                </>
            )}
            {(showMap && locations.length > 0) && (
                <MapBlade
                    title="Map"
                    subtitle={`Currently available in ${title}`}
                    className="community-map w-full max-w-screen-xl mx-auto px-5 lg:px-0 pt-20"
                    locations={locations}
                    mapProps={{
                        mapContainerStyle: {
                            width: "100%",
                            height: "830px"
                        }
                    }}
                    {...mapBladeProps}
                >
                </MapBlade>
            )}
            {showContactUsForm && <ContactForm {...contactUsFormProps} />}
        </>
    )
}

export default CommunityLayoutHeroGallery